import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  FormControl,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import {
  GetPayrollApproverAction,
  UpdatePayrollApproverAction,
} from "../../../../../store/Finance/PayrollManagement/Action";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";

const PayrollApproverConfig = () => {
  const theme = useTheme();
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
        position: "relative",
      },
      Backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        position: "absolute",
        borderRadius: "inherit",
      },
    })
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const { payrollApproverLoading, payroll_approver_data } = useSelector(
    (state) => state.FinanceReducer?.PayrollManagementReducer
  );
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );

  const [inputData, setInputData] = useState({ employee_id: "" });

  const [error, setError] = useState("");

  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const handleEmployees = () => {
    employees_options &&
      setEmployeesData({
        load: false,
        values: employees_options?.filter(
          (el) =>
            el?.core_hr_user_type === "Owner" ||
            el?.core_hr_user_type === "Admin" ||
            el?.enable_payroll_executive ||
            el?.enable_finance_executive
        ),
      });
  };
  useEffect(() => {
    dispatch(GetPayrollApproverAction());
    dispatch(GetEmployeesAction({ is_active: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (payroll_approver_data?.payroll_approver_pk) {
      setInputData({
        employee_id: {
          employee_id: payroll_approver_data?.payroll_approver_employee_pk,
          name: payroll_approver_data?.payroll_approver_employee_name,
        },
      });
    }
  }, [payroll_approver_data]);
  const handleSubmit = () => {
    if (!inputData?.employee_id) {
      setError("This field is required.");
      return;
    }
    dispatch(
      UpdatePayrollApproverAction({
        approver_employee_fk: inputData?.employee_id?.employee_id,
        payroll_approver_id: payroll_approver_data?.payroll_approver_pk,
      })
    );
  };

  return (
    <Grid item xs={12}>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", justifyContent: "left" }}
      >
        <Paper
          className={classes.Paper}
          sx={{
            padding: "10px 0px",
            borderRadius: "16px",
            width: "100%",
            minHeight: "140px",
          }}
        >
          <Backdrop className={classes.Backdrop} open={payrollApproverLoading}>
            <CircularProgress />
          </Backdrop>
          <Grid
            container
            display={"flex"}
            justifyContent={"space-between"}
            pt={"5px"}
          >
            <Grid item xs={10} md={7}>
              <FormControl fullWidth>
                <SelectableSearch
                  label="Select Approver"
                  value={inputData?.employee_id}
                  loading={handleEmployees}
                  fieldLabel="name"
                  required={true}
                  variant={"outlined"}
                  name="employee_id"
                  size="small"
                  onChangeEvent={(e, v) => {
                    setError("");
                    setInputData({ employee_id: v });
                  }}
                  data={employeesData}
                  {...(Boolean(error) && {
                    error: true,
                    helperText: error,
                  })}
                />
              </FormControl>
            </Grid>
            <Grid xs={2} md={3} display={"flex"} justifyContent={"end"}>
              <Box>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  onClick={handleSubmit}
                  className="mpl-primary-btn"
                >
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Typography
            variant="body1"
            sx={{
              marginTop: "17px",
              padding: "10px",
              backgroundColor: theme.palette.grey[200],
              borderRadius: "5px",
            }}
          >
            {"Assigned approver has sole authority over payroll approval."}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PayrollApproverConfig;
